import { render, staticRenderFns } from "./OrganizerCategories.vue?vue&type=template&id=57d6b522&"
import script from "./OrganizerCategories.vue?vue&type=script&lang=js&"
export * from "./OrganizerCategories.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports